export const LOGO = ({ fill, width=100, height=100 }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}pt`}
      height={`${height}pt`}
      viewBox="0 0 500.000000 500.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M3503 3334 c-86 -43 -287 -353 -398 -613 -37 -87 -104 -298 -106
-335 -1 -11 -5 2 -9 29 -8 55 34 341 69 469 33 120 80 240 116 297 41 63 43
88 11 118 -32 30 -55 22 -104 -37 -50 -60 -72 -104 -112 -227 -17 -55 -38
-114 -46 -132 -8 -18 -23 -92 -34 -165 -37 -243 -38 -245 -84 -308 -24 -33
-85 -128 -135 -212 -50 -84 -102 -166 -116 -183 -25 -30 -25 -30 -41 -10 -14
17 -15 43 -11 176 6 189 5 186 171 444 68 106 131 236 152 310 16 60 16 72 3
109 -18 51 -69 81 -123 70 -47 -8 -121 -74 -151 -135 -35 -68 -120 -328 -141
-429 -10 -47 -19 -87 -20 -89 -2 -2 -21 10 -42 27 -110 88 -147 67 -291 -168
-46 -74 -91 -146 -99 -160 -9 -14 -38 -49 -66 -78 -118 -126 -152 -97 -128
108 6 49 10 56 39 70 82 39 188 161 199 231 8 50 -10 88 -51 104 -118 50 -223
-39 -290 -245 -36 -111 -248 -430 -286 -430 -11 0 -12 38 0 76 5 16 28 91 52
167 40 130 42 138 26 155 -14 13 -33 16 -81 15 -39 -1 -71 3 -82 11 -16 12
-16 15 4 58 28 57 28 76 0 80 -38 6 -76 -12 -98 -47 -24 -39 -25 -73 -3 -119
19 -40 65 -61 111 -51 l28 6 -43 -128 c-26 -81 -42 -147 -43 -178 0 -85 54
-146 115 -131 43 11 155 133 214 234 30 50 55 92 56 92 1 0 2 -24 2 -54 0 -36
7 -66 20 -88 25 -44 87 -78 140 -78 58 0 103 41 188 175 37 58 68 105 69 105
1 0 2 -30 2 -67 0 -81 22 -129 66 -148 49 -20 84 -3 170 82 l78 78 0 -56 c0
-79 24 -152 61 -183 76 -64 123 -20 284 264 60 107 114 182 126 174 5 -3 9
-42 9 -87 0 -96 11 -141 42 -174 39 -42 108 -22 108 32 0 47 38 216 76 335 35
114 163 383 246 519 53 87 146 208 165 215 27 11 43 -14 43 -63 0 -50 -24
-135 -45 -161 -7 -8 -27 -44 -46 -80 -32 -61 -147 -188 -225 -247 l-29 -23 28
-25 c37 -33 73 -41 111 -25 63 26 91 24 126 -7 30 -27 33 -35 34 -89 0 -71
-28 -132 -103 -221 -100 -121 -328 -268 -475 -308 -94 -26 -85 -41 29 -52 149
-13 393 103 543 260 135 142 185 352 105 447 -35 42 -76 61 -134 63 l-50 2 38
30 c99 77 186 191 220 288 26 75 24 200 -3 251 -36 71 -96 98 -151 70z m-743
-279 c9 -10 11 -35 7 -76 -4 -47 -19 -88 -71 -192 -80 -160 -157 -300 -163
-294 -7 8 73 326 100 398 42 111 82 179 106 179 5 0 14 -7 21 -15z m855 -84
c-21 -43 -29 -39 -8 4 9 19 18 33 21 31 2 -2 -4 -18 -13 -35z m-1685 -449 c0
-37 -7 -54 -40 -98 -33 -44 -100 -105 -100 -91 0 22 64 188 85 218 21 33 29
38 41 28 8 -7 14 -30 14 -57z m975 -42 c-4 -17 -9 -29 -12 -26 -3 2 -2 19 2
36 4 17 9 29 12 26 3 -2 2 -19 -2 -36z m-551 -33 c19 -25 26 -46 26 -81 0 -96
-16 -128 -102 -212 -76 -74 -81 -77 -94 -59 -8 10 -14 28 -14 39 1 64 62 272
96 324 22 33 58 28 88 -11z m1132 -95 c-19 -53 -42 -87 -71 -106 -20 -13 -18
-7 14 39 21 30 44 68 51 85 18 44 23 30 6 -18z m-1825 -212 l-9 -45 -1 50 c0
28 3 61 7 75 7 25 7 25 10 -5 1 -16 -2 -50 -7 -75z"
        />
        <path
          d="M895 3097 c-17 -8 -53 -39 -80 -69 -53 -58 -169 -245 -180 -290 -4
-16 -11 -28 -15 -28 -17 0 -94 -199 -131 -342 -49 -188 -61 -341 -35 -430 20
-70 80 -135 163 -177 123 -62 162 -52 276 69 77 82 134 177 161 269 18 61 21
147 6 156 -5 3 -24 -23 -41 -57 -106 -210 -260 -368 -361 -368 -74 0 -103 95
-79 259 17 117 94 394 140 510 76 188 178 351 245 392 102 62 108 -42 15 -236
-22 -48 -39 -89 -36 -92 11 -10 75 19 114 52 55 47 75 92 74 170 -1 151 -125
262 -236 212z m-147 -364 c-22 -49 -62 -144 -89 -213 -26 -69 -48 -120 -49
-114 0 15 64 201 90 259 25 55 80 155 85 155 2 0 -15 -39 -37 -87z"
        />
        <path
          d="M4387 2865 c-22 -7 -50 -24 -64 -37 -28 -26 -83 -116 -103 -168 -8
-19 -39 -75 -69 -124 -31 -49 -68 -109 -82 -134 -33 -57 -135 -161 -166 -168
-40 -11 -48 8 -45 109 1 51 5 100 8 109 3 9 25 26 49 38 50 24 143 120 168
173 17 36 22 104 9 123 -29 43 -116 58 -171 30 -66 -34 -139 -154 -167 -273
-9 -38 -17 -115 -18 -173 -1 -95 1 -108 22 -138 29 -40 89 -72 137 -72 51 0
102 51 197 197 44 68 82 123 84 123 2 0 3 -38 2 -84 -2 -78 0 -87 26 -121 16
-21 47 -46 70 -56 101 -46 134 -20 293 226 133 207 137 215 125 227 -18 18
-37 2 -80 -69 -23 -37 -60 -97 -82 -133 -84 -136 -179 -220 -214 -191 -17 15
-20 55 -10 163 7 68 7 68 49 88 86 41 194 181 195 251 0 37 -35 77 -78 89 -44
12 -38 12 -85 -5z m81 -80 c2 -21 1 -48 -2 -61 -6 -24 -112 -144 -127 -144
-10 0 16 90 47 160 44 96 76 114 82 45z m-448 -14 c18 -34 11 -76 -21 -124
-34 -51 -101 -115 -106 -101 -5 16 45 153 72 200 29 49 39 53 55 25z m181
-391 l-9 -45 -1 50 c0 28 3 68 7 90 l7 40 3 -45 c1 -25 -2 -65 -7 -90z m-437
13 c-10 -88 -25 -111 -20 -32 3 61 10 89 22 89 2 0 1 -26 -2 -57z"
        />
      </g>
    </svg>
  );
};
